import React, { useEffect, useState } from 'react'
import { Box, Card, Button, CardContent, Grid, TextField, Typography } from '@mui/material'
import ReCAPTCHA from "react-google-recaptcha";
import SendIcon from '@mui/icons-material/Send';
import axios from 'axios';
import styled from '@emotion/styled';
import {Alert, variants} from '../alert/Alert';
import Spinner from '../spinner/Spinner';
// import API from '../../interceptors/axios'


const Contact = ({ sendPage }) => {

    const [captchaValidated, setCaptchaValidated] = useState(false)
    const [messageSent, setMessageSent] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        sendPage("contact")
        window.scrollTo(0,0)
    }, [])

    const delay = ms => new Promise(
        resolve => setTimeout(resolve, ms));

    const onChange = (value) => {
        // console.log("Captcha value:", value);
        setCaptchaValidated(true)
      }

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')
   
    const onSubmit = async (e) =>  {
    
        const token = localStorage.getItem("token");
        // axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        setIsLoading(true)        
        e.preventDefault()

        const config = {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`
            }
        }

        axios.post(
            `${process.env.REACT_APP_API_URL}/contacts/`, 
            {name, email, subject, message}, config)
        .then(res=> {
        })
        .catch(err => {           
        })

        

        await delay(2000)
        setName('')
        setEmail('')
        setSubject('')
        setMessage('')
        setMessageSent(true)
        setIsLoading(false)
    }

    const StyledSubmitButton = styled(Button)({
            width: 100,
            top: 10,
            backgroundColor: 'black',
            '&:hover': {
                color: "black",
                backgroundColor: "white",
            }
        });

    return (
        <Box align="center" sx={{
            backgroundColor: '#5C7373',            
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            width: "100%",
            justifyContent: "center",
        }}>
            <Typography
                height={150}
                align="center"
                color={"white"}
                variant="h2"
                sx={{ 
                    fontWeight: 900, 
                    top: 40, 
                    position: 'relative', 
                    textShadow: '4px 4px black', 
                    fontFamily: 'Light-1',
                    fontSize: { 
                            xs: '2rem',  // Small mobile devices (0-600px)
                            sm: '2.5rem',  // Tablets (600-900px)
                            md: '3rem',  // Small laptops (900-1200px)
                            lg: '3.5rem'      // Desktops (1200px+)
                        }, // Responsive font size
                     }}>
                Contact
            </Typography>
            <Card sx={{ width: '80%', }}> 
                <CardContent>   
                    <form onSubmit={e => onSubmit(e)}>                    
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="stretch">
                        
                        <Grid item sx={{ border: '1px', padding: 1 }}>
                            <TextField fullWidth required 
                                onChange={(e) => {setName(e.target.value)}}
                                value={name} type="text"
                                label="Name" placeholder='Type your name' variant='outlined' />
                        </Grid>
                        <Grid item sx={{ border: '1px', padding: 1 }}>
                            <TextField fullWidth required 
                                onChange={(e) => {setEmail(e.target.value)}}
                                value={email} type='email' 
                                label="Email" placeholder='Type your email' />
                        </Grid>
                        <Grid item sx={{ border: '1px', padding: 1 }}>
                            <TextField fullWidth required 
                                onChange={(e) => {setSubject(e.target.value)}}
                                value={subject} type='text' 
                                label="Subject" placeholder='Type your subject' />
                        </Grid>
                        <Grid item sx={{ border: '1px', padding: 1 }}>
                            <TextField fullWidth required 
                                onChange={(e) => {setMessage(e.target.value)}}
                                value={message} type='text' 
                                multiline rows={4} label="Message" placeholder='Type your message' />
                        </Grid>
                    </Grid>
                        {(messageSent && <Alert variant={variants[1]}/>)}
                    <hr/>
                    <Box align="right" width={'98%'} position={'relative'}>
                    <ReCAPTCHA
                            sitekey="6LeW-fYoAAAAAD6aN4LiF5IITLXDAoH1HjT8JtYV"
                            onChange={onChange}/>
                        {(!isLoading && !captchaValidated && <StyledSubmitButton 
                            type="submit"
                            variant="contained"
                            disabled={true}
                            endIcon={<SendIcon />}>
                            SEND
                        </StyledSubmitButton>)}
                        {(!isLoading && captchaValidated && <StyledSubmitButton 
                            type="submit"
                            variant="contained"
                            disabled={false}
                            endIcon={<SendIcon />}>
                            SEND
                        </StyledSubmitButton>)}
                        {(isLoading && <Spinner />)}
                        <br/>
                        <br/>
                    </Box>
                    </form>
                </CardContent>
 
            </Card>
            <br />
        </Box>
    )
}

export default Contact